import { Helmet } from 'react-helmet-async';

const PageTitle = ({ title }: { title: string }) => {
  // rendering page title component here
  return (
    <Helmet>
      <title>{title} || Global Academia</title>
    </Helmet>
  );
};

export default PageTitle;
